import { system } from '@config/system';
export const css = String.raw;
export const getParentSelector = (scope) => system.isHostedExperience ? `:where(${scope})` : scope;
